import { setupRoutes } from '../../helpers/routes/setup';
import COLD_PAGE from './cold-page';
import ROUTE from './route';

const {
  ROUTE_KEY,
  ROUTES,
  isColdPage,
  getRouteKeyForPath,
  getUrlForRouteKey,
  getRouteKeyOfChild,
} = setupRoutes(COLD_PAGE, ROUTE);

export {
  ROUTE_KEY,
  ROUTES,
  isColdPage,
  getRouteKeyForPath,
  getUrlForRouteKey,
  getRouteKeyOfChild,
};
